import { useEffect, useState } from "react";
import axios from "axios";

function useFetch(url) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check if the URL length is less than 46 characters
    if (url.length >= 46) {
      axios
        .get(url)
        .then((response) => {
          setData(response?.data);
        })
        .catch((err) => {
          setError(err);
        });
    } else {
      // Optionally handle the case where the URL is too long
      setError(new Error("URL is too long"));
    }
  }, [url]);

  return { data, error };
}

export default useFetch;
